import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import clsx from 'clsx';
import Environment from '@config/environment';
import { useTranslation } from 'next-i18next';
import styles from './address-modal.module.scss';
import AddressModalWrapper from './address-wrapper';

// TODO: Handle @vestiaire/vc-address-form to expose correct component types
// eslint-disable-next-line import/no-extraneous-dependencies, @typescript-eslint/no-unsafe-member-access
const AddressForm = dynamic(() => import('@vestiaire/vc-address-form').then((mod) => mod.AddressForm), { ssr: false });

type AddressScreen = 'book' | 'form_suggestion' | 'form_location' | 'form_contact' | 'default';
type AddressDisplayScreen = 'inPage' | 'inModal';
type AddressContext =
  | 'account'
  | 'checkout'
  | 'checkout_billing'
  | 'checkout_delivery'
  | 'deposit'
  | 'hyperwallet'
  | 'default'
  | 'tms_ko';

type EditAddressType = {
  clientId?: string;
  id: string;
  country: string;
  onSuccessCallback?: (res: { addressId: string; message: string }) => void;
};

export type AdserType = {
  displayScreen: AddressDisplayScreen;
  nextStepDisplay: AddressDisplayScreen;
  screen: AddressScreen;
  context: AddressContext;
  editAddress?: EditAddressType;
};

interface AddressModalProps {
  adserProps: AdserType;
  isOpen: boolean;
  onClose: () => void;
  title?: string;
}

const AddressModal = ({ adserProps, isOpen, onClose, title }: AddressModalProps) => {
  const { t } = useTranslation(['orders-sales', 'default-layout']);

  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const onLoadError = () => setIsError(true);

    // Handle show message when AddressForm loaded fail
    window.addEventListener('adserError', onLoadError);
    return () => {
      window.removeEventListener('adserError', onLoadError);
    };
  }, []);

  const wcConfig = {
    env: Environment.envName === 'teod' ? 'stage' : Environment.envName,
  };

  if (isError) {
    return (
      <AddressModalWrapper
        title={title}
        open={isOpen}
        onClose={onClose}
      >
        <p>{t('MY_ACCOUNT.ORDERS_SALES.POPUP.UPDATE_ADDRESS.ERROR_FORM_LOAD')}</p>
      </AddressModalWrapper>
    );
  }
  return (
    <>
      {/* Note: ModalWrapper is wrapped by isOpen to prevent unnecessary calls in Address Form */}
      {isOpen && (
        <AddressModalWrapper
          title={title}
          open={true}
          onClose={onClose}
        >
          <div className={clsx(styles.addressForm)}>
            <AddressForm
              // @ts-expect-error
              wcconfig={wcConfig}
              props={adserProps}
            />
          </div>
        </AddressModalWrapper>
      )}
    </>
  );
};

export default AddressModal;
